export default __webpack_public_path__ + "static/media/pilea.fdd918d6.jpg";